import React, { createContext, useEffect, useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom'

import { dateRangeConst } from 'constants/dateRangeConstants'
import moment from 'utils/momentInstanse'
import EquipmentPage from './EquipmentPage'
import {
  setEquipmentFacilityId,
  setEquipmentSelectedDateRangeRedirect,
  getEquipmentFilterData,
  getEquipmentConsamptionData,
  setDefaultDateSelect,
  clearSelectedFilterData,
} from 'redux/reducers/equipments'

const EquipmentContext = createContext()

const EquipmentContainer = () => {
  const { facilityId } = useParams()
  const { state } = useLocation()

  const reduxDispatch = useDispatch()

  const [selectedDevices, setSelectedDevices] = useState([])

  useEffect(() => {
    return () => reduxDispatch(clearSelectedFilterData())
  }, [reduxDispatch])

  useEffect(() => {
    if (state?.selectedDateRange) {
      reduxDispatch(
        setEquipmentSelectedDateRangeRedirect(state?.selectedDateRange)
      )
    } else {
      reduxDispatch(
        setDefaultDateSelect({
          id: dateRangeConst.currentMonth.id,
          label: dateRangeConst.currentMonth.label,
          value: {
            start_timestmp: moment().startOf('month').utc().unix(),
            end_timestmp: moment().endOf('month').utc().unix(),
          },
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxDispatch])

  useEffect(() => {
    if (facilityId) {
      reduxDispatch(setEquipmentFacilityId(facilityId))

      reduxDispatch(getEquipmentFilterData())
      reduxDispatch(getEquipmentConsamptionData())
    }
  }, [facilityId, reduxDispatch])

  return (
    <EquipmentContext.Provider
      value={{ setSelectedDevices, selectedDevices, facilityId }}
    >
      <EquipmentPage />
    </EquipmentContext.Provider>
  )
}

export const useEquipmentContext = () => {
  return useContext(EquipmentContext)
}

export default EquipmentContainer
